import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NotificationPermission from '~/constants/NotificationPermission';
import Status from '~/constants/Status';
import { RootReducerState } from '~/modules';
import { allowFCMAction } from '~/modules/AllowFCMModule';

type AllowDataType = RootReducerState['allowFCMReducer']['data'];
const useFCMAllow = (): [boolean, AllowDataType] => {
    const dispatch = useDispatch();

    type AllowFCMData = RootReducerState['allowFCMReducer'];
    const { data, status } = useSelector<RootReducerState, AllowFCMData>(
        ({ allowFCMReducer }) => allowFCMReducer
    );

    // 최초 fcm 기능 허용 체크 진행
    useEffect(() => {
        if (status !== Status.INITIAL) return;
        dispatch(allowFCMAction.checkAllow(false));
    }, [status, dispatch]);

    // 권한 허용 여부 확인
    const allow = useMemo(() => {
        if (status !== Status.SUCCESS || !data) return false;

        const { permission, support } = data;
        return support && permission === NotificationPermission.GRANTED;
    }, [data, status]);

    return [allow, data];
};

export default useFCMAllow;
